<template>
  <app-navigation>
    <v-layout justify-center>
      <v-container
        fluid
        grid-list-md>
        <v-layout row wrap justify-center>
          <v-flex xs6 sm3 md3 lg3 xl3
            pa-2
            v-for="menu in menu_list"
            :key="`${menu.name}${menu.id}`">
              <menu-card
                class="justify-menu"
                :name="menu.name"
                :url="menu.url"
                :picture="menu.picture_path"/>
          </v-flex>
        </v-layout>
      </v-container>
    </v-layout>
  </app-navigation>
</template>

<script>
import AppNavigation from '@/layouts/AppNavigation'
import * as api from '@/api'
import { message } from '@/mixins'
import MenuCard from '@/components/MenuCard'

export default {
  name: 'home',

  components: {
    AppNavigation,
    MenuCard
  },

  mixins: [message],

  data: () => ({
    menu_list: [
      {
        key: 0,
        icon: 'people',
        url: '/registro/estudantes/',
        name: 'Estudantes',
        picture_path: require('@/assets/images/registry.png')
      },
      {
        key: 1,
        icon: 'restaurant',
        url: '/refeicoes/estudantes/',
        name: 'Controle de Refeições',
        picture_path: require('@/assets/images/mealreport.png')
      }
    ]
  }),

  mounted () {
    api.responsibleMenu.get().then(({ data }) => {
      this.menu_list.push(...this.sortItems(data))
    }).catch(this.handleErrorMessage)
  },

  methods: {
    sortItems (items) {
      return items.sort((a, b) => a.sequence - b.sequence)
    }
  }
}
</script>

<style lang="stylus" scoped>
.justify-menu
  justify-content center
</style>
